<template>
  <div>
    <!-- REVENDAS (quando não é Nuts) -->
    <b-row v-if="idRevenda != 1 && !isNuts">
      <div class="card-form">
        <div class="card-list">
          <div class="card-form-assinatura__inner">
            <div class="card-input" style="padding-top: 30px">
              <h3>Verifique sua assinatura com nosso Parceiro:</h3>
              <br />
              <h3 style="text-align: center">
                {{ dadosRevenda.nome_revenda }} <br />
                Telefone: {{ dadosRevenda.fone_revenda }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </b-row>

    <!-- ================= RENOVAÇÃO ================= -->
    <b-row>
      <b-col class="justify-content-center" md="12" v-if="ocultaPlans && idRevenda === 1">
        <div class="card-form shadow h-100">
          <div class="card-form-assinatura__inner p-4">
            <!-- HEADER -->
            <div class="text-center mb-4">
              <h6 class="text-muted">Dúvidas? (49) 3550 0600</h6>
              <h2>🚀 Continue crescendo com a Nuts</h2>

              <p class="text-muted mb-1">
                Você está no plano <strong>{{ assinatura.plano }}</strong>
              </p>

              <p class="valor-destaque">
                R$ {{ formatValorReal(assinatura.valor) }}
              </p>

              <small class="text-muted">
                Válido até {{ formatDate(assinatura.data_validade) }}
              </small>
            </div>

            <!-- STEPS -->
            <div class="assinatura-steps mb-4" v-if="planoAtual && showAssinaturaCard">
              <div :class="['step-item', { active: step >= 1 }]">
                1. Pagamento
              </div>
              <div :class="['step-item', { active: step >= 2 }]">
                2. Plugins
              </div>
              <div :class="['step-item', { active: step >= 3 }]">
                3. Finalizar
              </div>
            </div>

            <div v-if="planoAtual && showAssinaturaCard">
              <!-- ================= STEP 1 ================= -->
              <div v-if="step === 1">
                <h5 class="text-center mb-3">
                  Escolha a forma de pagamento
                </h5>

                <div class="pagamentos-grid">
                  <div v-for="(opcao, key) in opcoesOrdenadas" :key="key" class="payment-card"
                    :class="{ selected: opcaoSelecionada === key }" @click="selecionarOpcao(key)">
                    <div class="payment-title">
                      <span>{{ opcao.icon }}</span>
                      <strong>{{ opcao.label }}</strong>
                    </div>

                    <div class="price-main">
                      <template v-if="opcao.parcela">
                        {{ opcao.parcela }}x de
                        R$ {{ formatValorReal(opcao.valor) }}
                      </template>

                      <template v-else-if="opcao.mensal">
                        R$ {{ formatValorReal(opcao.valor) }} / mês
                      </template>

                      <template v-else>
                        R$ {{ formatValorReal(opcao.valor) }}
                      </template>
                    </div>

                    <small v-if="opcao.destaque" class="text-success d-block">
                      {{ opcao.destaque }}
                    </small>

                    <small v-if="opcao.sub" class="text-muted d-block mt-1">
                      {{ opcao.sub }}
                    </small>
                  </div>
                </div>

                <div class="text-center mt-4">
                  <b-button variant="primary" size="lg" :disabled="!opcaoSelecionada" @click="step = 2">
                    Continuar →
                  </b-button>
                </div>
              </div>

              <!-- ================= STEP 2 ================= -->
              <div v-if="step === 2" class="plugins-box mt-4">
                <h5 class="text-center mb-1">
                  🚀 Turbine seu sistema
                </h5>

                <p class="text-center text-muted mb-4">
                  Aproveite estes recursos extras com desconto exclusivo para
                  clientes Nuts
                </p>

                <b-row>
                  <!-- CERTIFICADO -->
                  <b-col md="6">
                    <div class="plugin-card destaque" @click="togglePlugin('certificado')">
                      <div class="plugin-badge">
                        🔥 Mais vendido
                      </div>

                      <b-form-checkbox v-model="plugins.certificado.ativo" switch class="mb-2" @click.stop>
                        Certificado Digital A1
                      </b-form-checkbox>

                      <div class="plugin-price">
                        <span class="old-price">
                          R$ 250,00
                        </span>

                        <span class="new-price">
                          R$ {{ formatValorReal(plugins.certificado.valor) }}
                        </span>
                      </div>

                      <div class="plugin-desc">
                        Emita NF-e sem complicação. Instalação automática no
                        sistema.
                      </div>
                    </div>
                  </b-col>

                  <!-- TEF -->
                  <b-col md="6">
                    <div class="plugin-card" @click="togglePlugin('tef')">
                      <div class="plugin-badge blue">
                        💳 PDV Completo
                      </div>

                      <b-form-checkbox v-model="plugins.tef.ativo" switch class="mb-2" @click.stop>
                        TEF Integrado
                      </b-form-checkbox>

                      <div class="plugin-price">
                        <span class="new-price">
                          + R$ {{ formatValorReal(plugins.tef.valor) }}
                        </span>
                      </div>

                      <div class="plugin-desc">
                        Conecte maquininhas direto no PDV. Mais rapidez no
                        caixa.
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <div class="d-flex justify-content-between mt-4">
                  <b-button variant="outline-secondary" @click="step = 1">
                    ← Voltar
                  </b-button>

                  <b-button variant="success" size="lg" @click="step = 3">
                    Continuar →
                  </b-button>
                </div>
              </div>

              <!-- ================= STEP 3 ================= -->
              <div v-if="step === 3">
                <div v-if="opcaoSelecionada === 'pix' && pixGerado && !pixConfirmado"
                  class="alert alert-warning d-flex align-items-start mb-3 aviso-pix-pendente">
                  <div class="mr-2" style="font-size: 20px">⚠️</div>
                  <div>
                    <strong>Pagamento PIX em processamento</strong>
                    <div class="mb-1">
                      Não atualize e não feche esta tela até a confirmação automática do pagamento.
                    </div>
                    <small class="text-muted">
                      Assim que identificarmos o pagamento, a renovação será concluída automaticamente.
                    </small>
                  </div>
                </div>
                <div class="card-resumo shadow">
                  <h5 class="mb-3">
                    Resumo da renovação
                  </h5>

                  <div class="resumo-item">
                    <span>Plano</span>
                    <strong>{{ assinatura.plano }}</strong>
                  </div>

                  <div class="resumo-item">
                    <span>Valor do plano</span>
                    <strong>R$ {{ formatValorReal(valorPlano) }}</strong>
                  </div>

                  <div v-if="plugins.certificado.ativo" class="resumo-item">
                    <span>Certificado Digital</span>
                    <strong>
                      R$ {{ formatValorReal(plugins.certificado.valor) }}
                    </strong>
                  </div>

                  <div v-if="plugins.tef.ativo" class="resumo-item">
                    <span>TEF Integrado</span>
                    <strong>
                      R$ {{ formatValorReal(plugins.tef.valor) }}
                    </strong>
                  </div>

                  <hr />

                  <div class="resumo-total">
                    <span>Total</span>
                    <strong>
                      R$ {{ formatValorReal(valorSelecionado) }}
                    </strong>
                  </div>

                  <!-- CTA -->
                  <b-button variant="success" block size="lg" class="mt-3"
                    :disabled="!opcaoSelecionada || isLoading || pixLoading" @click="iniciarPagamento">
                    🚀 Renovar agora
                  </b-button>

                  <!-- ================= PIX (gerado somente no passo 3) ================= -->
                  <div v-if="opcaoSelecionada === 'pix' && pixGerado" class="pix-box mt-3 text-center">
                    <img v-if="qrCodePix" :src="qrCodePix" class="pix-qrcode" />

                    <b-button v-if="codigoPix" class="mt-2" size="sm" variant="outline-secondary" @click="copiarPix">
                      Copiar PIX
                    </b-button>

                    <div class="pix-warning-text mt-3">
                      <strong>Importante:</strong> após realizar o pagamento, mantenha esta tela aberta até a
                      confirmação automática.
                    </div>

                    <small v-if="pixExpirationDate" class="text-muted d-block mt-2">
                      Expira em {{ formatDateTime(pixExpirationDate) }}
                    </small>
                  </div>

                  <!-- ================= CARTÃO (abre somente no passo 3) ================= -->
                  <div v-if="
                    opcaoSelecionada &&
                    String(opcaoSelecionada).startsWith('cartao') &&
                    chamaCartao
                  " class="mt-3">
                    <CardForm @card-success="handleCardSuccess" :form-data="formData"
                      @input-card-number="updateCardNumber" @input-card-name="updateCardName"
                      @input-card-month="updateCardMonth" @input-card-year="updateCardYear"
                      @input-card-cvv="updateCardCvv" :plano="assinatura.plano" :valor="valorSelecionado"
                      :id_plan="assinatura.id_plan" :vezesByPlan="vezesByPlan" :isSale="true" />
                  </div>
                </div>

                <div class="text-center mt-4">
                  <b-button variant="outline-secondary" class="mr-2" @click="step = 2">
                    ← Voltar
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- ================= HISTÓRICO ================= -->
    <b-row class="mt-5 justify-content-center" v-if="ocultaPlans && idRevenda === 1 && itemsTable.length">
      <b-col md="10" lg="8">
        <div class="card-form shadow-sm bloco-faturas">
          <div class="card-form-assinatura__inner p-4">
            <h5 class="mb-3">Histórico de faturas</h5>

            <b-table :items="itemsTable" :fields="fieldsAssinaturas" small responsive :busy="assinaturasLoading">
              <template #table-busy>
                <div class="text-center w-100 my-3">
                  <b-spinner class="mr-2" small></b-spinner>
                  Carregando faturas...
                </div>
              </template>

              <template #empty>
                <div class="text-center text-muted my-3">
                  Nenhuma fatura encontrada.
                </div>
              </template>

              <template #cell(data_vencimento)="row">
                {{ formatDate(row.item.data_vencimento) }}
              </template>

              <template #cell(valor)="row">
                R$ {{ formatValorReal(row.item.valor) }}
              </template>

              <template #cell(status)="row">
                <b-badge :variant="row.item.pagamento
                  ? 'success'
                  : isOverdue(row.item)
                    ? 'danger'
                    : 'warning'
                  ">
                  {{
                    row.item.pagamento
                      ? 'Paga'
                      : isOverdue(row.item)
                        ? 'Vencida'
                        : 'Pendente'
                  }}
                </b-badge>
              </template>

              <template #cell(acoes)="row">
                <b-button v-if="row.item.url_boleto && !row.item.pagamento" :href="row.item.url_boleto" target="_blank"
                  size="sm" variant="outline-primary">
                  Abrir boleto
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- SEM PLANO -->
    <b-row class="plan__table" v-if="dataReady && !ocultaPlans && !isRevenda && !assinatura.assinatura_diferenciada && !isNuts">
      <b-col md="12">
        <div class="plan-picker card-form shadow p-3 plan-card--alert">
          <div class="plan-card__header bg-warning text-dark">
            <h5 class="m-0">⚠ Você ainda está sem plano</h5>
          </div>

          <div class="plan-card__body">
            <p class="mb-3">
              Identificamos que sua empresa ainda não possui um plano ativo. Para
              continuar utilizando o sistema, verifique sua assinatura com a
              Nuts.
            </p>

            <b-button variant="success" block @click="abrirWhatsApp">
              Falar com a Nuts no WhatsApp
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- parceiros -->
    <b-row v-if="isRevenda && idRevenda === 1">
      <b-col class="justify-content-center" md="12">
        <div class="card-form shadow h-100">
          <div class="card-form-assinatura__inner p-4">
            <!-- HEADER -->
            <div class="text-center mb-4">
              <h6 class="text-muted">Dúvidas? (49) 3550 0600</h6>
              <h2>🚀 Continue crescendo com a Nuts</h2>

              <p class="text-muted mb-1">
                Você está no plano <strong>{{ assinatura.plano }}</strong>
              </p>

              <p class="valor-destaque">
                R$ {{ formatValorReal(assinatura.valor) }}
              </p>

              <small class="text-muted">
                Válido até {{ formatDate(assinatura.data_validade) }}
              </small>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- cliente diferenciado -->
    <b-row v-if="assinatura.assinatura_diferenciada">
      <b-col class="justify-content-center" md="12">
        <div class="card-form shadow h-100">
          <div class="card-form-assinatura__inner p-4">
            <!-- HEADER -->
            <div class="text-center mb-4">
              <h6 class="text-muted">Dúvidas? (49) 3550 0600</h6>
              <h2>🚀 Continue crescendo com a Nuts</h2>

              <p class="text-muted mb-1">
                Você está no plano <strong>{{ assinatura.plano }}</strong>
              </p>

              <p class="valor-destaque">
                R$ {{ formatValorReal(assinatura.valor) }}
              </p>

              <small class="text-muted">
                Válido até {{ formatDate(assinatura.data_validade) }}
              </small>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin, FormatMixin } from "@/modules/Application";
import { mapGetters, mapActions } from "vuex";
import AssinaturaData, { AssinaturaDataRequired } from "./AssinaturaData";
import CardForm from "../Cards/CardForm";

export default {
  name: "app-assinatura-renovacao-2026",
  mixins: [validationMixin, SistemaMixin, FormatMixin],
  components: { CardForm },

  data() {
    return {
      dataReady: false,
      ocultaPlans: true,
      step: 1,

      assinatura: {},

      plugins: {
        certificado: {
          nome: "Certificado Digital A1",
          valor: 190,
          ativo: false,
        },
        tef: {
          nome: "TEF Integrado",
          valor: 1069.90,
          ativo: false,
        },
      },

      // TABELA
      assinaturas: [],
      assinaturasLoading: false,

      // Loading
      isLoading: false,
      pixLoading: false,

      // Pagamento
      opcaoSelecionada: null,

      // CARTÃO (CardForm)
      chamaCartao: false,
      vezesByPlan: 1,
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
      },

      // PIX
      pixPaymentId: null,
      qrCodePix: null,
      codigoPix: null,
      pixPollTimer: null,
      pixExpirationDate: null,

      pixGerado: false,
      pixLastAmount: null,
      pixConfirmado: false,
      bloquearSaidaPix: false,
      // Regras 2026
      planos2026: {}
    }
  },

  validations: { form: AssinaturaDataRequired },

  computed: {
    ...mapGetters(["itsblocked", "idRevenda", "dadosRevenda", "licenca", "isRevenda", "isNuts"]),

    showAssinaturaCard() {
      if (this.idRevenda != 1) return false;

      const planosValidos = ["1", "2", "3", "4", "6", "7"];
      if (!planosValidos.includes(String(this.assinatura.id_plan))) return false;

      if (!this.assinatura.data_validade) return true;

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const validade = new Date(this.assinatura.data_validade);
      validade.setHours(0, 0, 0, 0);

      return hoje > validade;
    },

    planoAtual() {
      return this.planos2026[String(this.assinatura.id_plan)] || null;
    },

    opcoesOrdenadas() {
      if (!this.planoAtual) return {};
      const { prioridade, opcoes } = this.planoAtual;

      const ordered = {};
      (prioridade || []).forEach((k) => {
        if (opcoes[k]) ordered[k] = opcoes[k];
      });

      Object.keys(opcoes || {}).forEach((k) => {
        if (!ordered[k]) ordered[k] = opcoes[k];
      });

      return ordered;
    },

    valorPlano() {
      if (!this.planoAtual || !this.opcaoSelecionada) return 0;
      return Number(this.planoAtual.opcoes?.[this.opcaoSelecionada]?.valor_total ?? 0);
    },

    valorPlugins() {
      return Object.values(this.plugins)
        .filter((p) => p.ativo)
        .reduce((acc, p) => acc + Number(p.valor || 0), 0);
    },

    valorSelecionado() {
      return Number(this.valorPlano) + Number(this.valorPlugins);
    },

    modalidadeSelecionada() {
      if (!this.planoAtual || !this.opcaoSelecionada) return null;
      return this.planoAtual.opcoes?.[this.opcaoSelecionada]?.modalidade || null;
    },

    // tabela
    itemsTable() {
      return (this.assinaturas || []).map((b) => ({
        data_vencimento: b.data_vencimento,
        valor: b.valor,
        pagamento: !!b.recebido,
        url_boleto: b.url_boleto,
      }));
    },

    fieldsAssinaturas() {
      return [
        { key: "data_vencimento", label: "Vencimento" },
        { key: "valor", label: "Valor" },
        { key: "status", label: "Status" },
        { key: "acoes", label: "Ações" },
      ];
    },
  },

  watch: {
    // Se mudou valor final (plugins), invalida PIX gerado para evitar QR errado
    valorSelecionado() {
      if (this.opcaoSelecionada === "pix" && this.pixGerado) {
        this.resetPixState();
      }
    },
  },

  beforeDestroy() {
    this.stopPixPolling();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  async mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    await this.getDataInitSafe();
  },

  methods: {
    ...mapActions(["setLoading"]),

    // ===== CardForm handlers =====
    updateCardNumber(v) {
      this.formData.cardNumber = v;
    },
    updateCardName(v) {
      this.formData.cardName = v;
    },
    updateCardMonth(v) {
      this.formData.cardMonth = v;
    },
    updateCardYear(v) {
      this.formData.cardYear = v;
    },
    updateCardCvv(v) {
      this.formData.cardCvv = v;
    },

    togglePlugin(key) {
      if (!this.plugins?.[key]) return;
      this.plugins[key].ativo = !this.plugins[key].ativo;
    },

    handleBeforeUnload(event) {
      if (!this.bloquearSaidaPix) return;

      event.preventDefault();
      event.returnValue = "";
    },

    // ===== INIT =====
    async getDataInitSafe() {
      this.setLoading(true);
      try {
        this.dataReady = true;
        const dataPlanos = await this.$http.post("/empresa/planos-ativos");

        if (dataPlanos.data) {
          this.planos2026 = dataPlanos.data.planos2026;
        }

        const data = await this.getAssinaturaByClient();
        this.assinatura = new AssinaturaData(data);

        if (this.plugins?.certificado) {
          this.plugins.certificado.ativo = !!data.plugin_certificado;
        }

        if (this.plugins?.tef) {
          this.plugins.tef.ativo = !!data.plugin_tef;
        }

        this.ocultaPlans = !(Number(this.assinatura.id_plan) === 1);

        if (this.assinatura.id_empresa === 1) {
          this.ocultaPlans = false;
        }

        if (this.isRevenda) {
          this.ocultaPlans = false;
        }

        if (this.assinatura.assinatura_diferenciada) {
          this.ocultaPlans = false;
        }

        await this.carregarAssinaturas();
      } finally {
        this.setLoading(false);
      }
    },

    async handleCardSuccess() {
      await this.finalizarRenovacao();
    },

    async carregarAssinaturas() {
      this.assinaturasLoading = true;
      try {
        const res = await this.$http.post("/empresa/fatura-assinaturas");
        this.assinaturas = res?.data?.assinaturas || [];
      } catch (e) {
        this.assinaturas = [];
      } finally {
        this.assinaturasLoading = false;
      }
    },

    // ===== Format =====
    formatValorReal(value) {
      const num = Number(String(value ?? 0).replace(",", "."));
      return (isNaN(num) ? 0 : num).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatDate(dt) {
      if (!dt) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(dt)) {
        const [y, m, d] = dt.split("-").map(Number);
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString("pt-BR");
      }
      const date = new Date(dt);
      return isNaN(date) ? "" : date.toLocaleDateString("pt-BR");
    },

    formatDateTime(dt) {
      if (!dt) return "";
      const date = new Date(String(dt).replace(" ", "T"));
      return isNaN(date) ? dt : date.toLocaleString("pt-BR");
    },

    // ===== Seleção de pagamento (SEM back aqui) =====
    async selecionarOpcao(key) {
      this.opcaoSelecionada = key;

      // reset UI final
      this.chamaCartao = false;

      // trocar forma de pagamento invalida pix anterior
      this.resetPixState();

      // só define parcelas (CardForm abre apenas no passo 3, no clicar Renovar agora)
      if (String(key).startsWith("cartao")) {
        const parcela = this.planoAtual?.opcoes?.[key]?.parcela;
        this.vezesByPlan = Number(parcela || 1);
      }
    },

    // ===== CTA FINAL =====
    async iniciarPagamento() {
      if (!this.opcaoSelecionada) {
        this.$toast?.danger?.("Selecione uma forma de pagamento.");
        return;
      }

      if (this.step !== 3) {
        this.step = 3;
        return;
      }

      // PIX: só gera aqui (passo 3)
      if (this.opcaoSelecionada === "pix") {
        const precisaRegerar =
          this.pixLastAmount !== Number(this.valorSelecionado) || !this.pixGerado;

        await this.gerarPixQRCode(precisaRegerar);
        return;
      }

      // Cartão: abre CardForm aqui
      if (String(this.opcaoSelecionada).startsWith("cartao")) {
        this.chamaCartao = true;

        this.$nextTick(() => {
          const el = this.$el.querySelector(".card-resumo");
          el?.scrollIntoView?.({ behavior: "smooth", block: "start" });
        });

        return;
      }

      // Boleto / outros
      await this.finalizarRenovacao();
    },

    // ===== PIX helpers =====
    resetPixState() {
      this.stopPixPolling?.();
      this.pixPaymentId = null;
      this.qrCodePix = null;
      this.codigoPix = null;
      this.pixExpirationDate = null;
      this.pixGerado = false;
      this.pixLastAmount = null;
      this.pixConfirmado = false;
      this.bloquearSaidaPix = false;
    },

    async gerarPixQRCode(force = false) {
      if (this.step !== 3) return;

      if (!this.valorSelecionado || Number(this.valorSelecionado) <= 0) {
        this.$toast?.danger?.("Não foi possível calcular o valor do PIX.");
        return;
      }

      if (!force && this.pixPaymentId && this.qrCodePix && this.codigoPix) {
        this.startPixPolling();
        this.pixGerado = true;
        this.bloquearSaidaPix = true;
        return;
      }

      this.stopPixPolling?.();
      this.pixLoading = true;

      this.pixGerado = false;
      this.pixConfirmado = false;
      this.bloquearSaidaPix = true;
      this.qrCodePix = null;
      this.codigoPix = null;
      this.pixPaymentId = null;
      this.pixExpirationDate = null;

      try {
        this.setLoading(true);

        const res = await this.$http.post("/boletos/pix", {
          id_empresa: this.assinatura.id_empresa,
          id_assinatura: this.assinatura.id_assinatura,
          id_plan: this.assinatura.id_plan,
          modalidade: this.modalidadeSelecionada,
          forma_pagamento: "pix",
          valor: this.valorSelecionado,
          email_fatura: this.licenca.email,
          cnpj_cpf: this.assinatura.cnpj_cpf,
          plugins: Object.keys(this.plugins)
            .filter((k) => this.plugins[k]?.ativo)
            .map((k) => ({
              key: k,
              nome: this.plugins[k].nome,
              valor: this.plugins[k].valor,
            })),
        });

        const data = res?.data || {};

        this.pixPaymentId = data.id || null;

        if (data.encodedImage) {
          this.qrCodePix = `data:image/png;base64,${data.encodedImage}`;
        } else {
          this.qrCodePix = data.qrcode_base64 || null;
        }

        this.codigoPix = data.payload || data.copia_cola || null;
        this.pixExpirationDate = data.expirationDate || null;

        if (this.pixPaymentId) {
          this.pixGerado = true;
          this.pixLastAmount = Number(this.valorSelecionado);
          this.startPixPolling();
        } else {
          this.bloquearSaidaPix = false;
          this.$toast?.danger?.("Não foi possível gerar o PIX (ID ausente).");
        }
      } catch (e) {
        this.bloquearSaidaPix = false;
        this.$toast?.danger?.("Erro ao gerar PIX. Tente novamente.");
      } finally {
        this.pixLoading = false;
        this.setLoading(false);
      }
    },

    startPixPolling() {
      this.stopPixPolling();
      this.pixPollTimer = setInterval(() => this.checkPixStatus(), 8000);
    },

    stopPixPolling() {
      if (this.pixPollTimer) clearInterval(this.pixPollTimer);
      this.pixPollTimer = null;
    },

    async checkPixStatus() {
      if (!this.pixPaymentId) return;

      try {
        const res = await this.$http.post('/boletos/status-pix/', {
          id_pix: this.pixPaymentId
        });

        const pagamentos = res?.data?.data || [];

        const pagamentoPix = pagamentos.find(
          item => item.pixQrCodeId === this.pixPaymentId
        );

        const status = pagamentoPix?.status;

        if (status === "RECEIVED") {
          this.pixConfirmado = true;
          this.bloquearSaidaPix = false;
          this.$toast?.success?.("Pagamento confirmado! Renovação ativada.");
          this.stopPixPolling();
          this.finalizarRenovacao();
        }
      } catch (e) {
        // mantém polling
      }
    },

    async copiarPix() {
      try {
        await navigator.clipboard.writeText(this.codigoPix || "");
        this.$toast?.success?.("Código PIX copiado!");
      } catch {
        this.$toast?.danger?.("Não foi possível copiar. Copie manualmente.");
      }
    },

    // ===== Boleto / outros =====
    async finalizarRenovacao() {
      if (!this.opcaoSelecionada) {
        return this.$toast?.danger?.("Selecione uma forma de pagamento.");
      }

      this.isLoading = true;
      this.setLoading(true);

      try {
        await this.$http.post("/contrato-fatura/assinatura", {
          id_empresa: this.assinatura.id_empresa,
          id_assinatura: this.assinatura.id_assinatura,
          id_plan: this.assinatura.id_plan,
          modalidade: this.modalidadeSelecionada,
          forma_pagamento: this.opcaoSelecionada,
          valor: this.valorSelecionado,
          cnpj_cpf: this.assinatura.cnpj_cpf,
          email_fatura: this.licenca.email,

          // plugins selecionados (pra registrar do mesmo jeito do pix)
          plugins: Object.keys(this.plugins)
            .filter((k) => this.plugins[k]?.ativo)
            .map((k) => ({
              key: k,
              nome: this.plugins[k].nome,
              valor: this.plugins[k].valor,
            })),
        });

        this.$toast?.success?.("Renovação iniciada com sucesso!");
      } catch (e) {
        this.$toast?.danger?.("Erro ao renovar. Chame um consultor da Nuts.");
      } finally {
        this.isLoading = false;
        this.setLoading(false);
      }
    },

    abrirWhatsApp() {
      const numero = "554935500600";
      const mensagem = encodeURIComponent(
        "Olá, estou sem plano ativo no sistema e gostaria de verificar minha assinatura."
      );
      window.open(`https://wa.me/${numero}?text=${mensagem}`, "_blank");
    },

    isOverdue(item) {
      if (item.pagamento) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const due = new Date(item.data_vencimento);
      due.setHours(0, 0, 0, 0);

      return due < today;
    },
  },
};
</script>

<style lang="scss">
/* visual geral */
.bloco-faturas {
  margin-top: 60px;
  margin-bottom: 150px;
}

.card-form {
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.card-form-assinatura__inner {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
}

.valor-destaque {
  font-size: 1.5rem;
  font-weight: 800;
  color: #ee7361;
}

/* steps */
.assinatura-steps {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.step-item {
  padding: 10px 18px;
  border-radius: 30px;
  background: #eee;
}

.step-item.active {
  background: #ee7361;
  color: white;
  font-weight: 600;
}

/* cards pagamento */
.pagamentos-grid {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.payment-card {
  flex: 1 1 190px;
  border: 2px solid #eee;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.payment-card:hover {
  border-color: #ee7361;
  transform: translateY(-3px);
}

.payment-card.selected {
  border-color: #ee7361;
  background: #fff7f5;
}

.payment-title {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
}

.price-main {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ee7361;
  margin-top: 10px;
  line-height: 1.2;
}

/* plugins */
.plugins-box {
  background: #f7f9fc;
  padding: 18px;
  border-radius: 12px;
}

.plugin-card {
  border: 2px solid #eee;
  border-radius: 12px;
  padding: 18px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.plugin-card:hover {
  border-color: #ee7361;
  transform: translateY(-3px);
}

.plugin-card.destaque {
  border-color: #ee7361;
  background: #fff7f5;
}

.plugin-badge {
  position: absolute;
  top: -10px;
  left: 15px;
  background: #ee7361;
  color: #fff;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 20px;
}

.plugin-badge.blue {
  background: #4f6df5;
}

.plugin-price {
  margin: 5px 0;
}

.old-price {
  text-decoration: line-through;
  color: #999;
  font-size: 13px;
  margin-right: 6px;
}

.new-price {
  font-size: 18px;
  font-weight: 700;
  color: #ee7361;
}

.plugin-desc {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

/* resumo */
.card-resumo {
  background: #fff;
  border-radius: 10px;
  padding: 24px;
}

.resumo-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.resumo-total {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 700;
  color: #ee7361;
}

/* PIX */
.pix-box {
  background: #f7f9fc;
  padding: 18px;
  border-radius: 12px;
}

.pix-qrcode {
  max-width: 240px;
  width: 100%;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
}

/* sem plano */
.plan__table {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 1024px;
  margin: 0 auto;
}

.plan-card--alert {
  border: 2px solid #ee7361;
  background: #fff7f5;
}

.plan-card--alert .plan-card__header {
  font-weight: 600;
}
.aviso-pix-pendente {
  border: 1px solid #f3c36b;
  background: #fff8e8;
  border-radius: 10px;
}

.pix-warning-text {
  font-size: 13px;
  color: #9a6700;
  background: #fff8e8;
  border: 1px solid #f3c36b;
  padding: 10px 12px;
  border-radius: 8px;
}
</style>